module.exports = __webpack_public_path__ + "static/media/Falcon901_4c.45e56b07.svg";